import {
  HTTP_MEETINGS_FETCHING,
  HTTP_MEETINGS_SUCCESS,
  HTTP_MEETINGS_FAILED,
  
  HTTP_MEETING_FETCHING,
  HTTP_MEETING_SUCCESS,
  HTTP_MEETING_FAILED,

  HTTP_EVENT_FETCHING,
  HTTP_EVENT_SUCCESS,
  HTTP_EVENT_FAILED,

  HTTP_DOCUMENTS_FETCHING,
  HTTP_DOCUMENTS_SUCCESS,
  HTTP_DOCUMENTS_FAILED,

  HTTP_ATTENDEES_FETCHING,
  HTTP_ATTENDEES_SUCCESS,
  HTTP_ATTENDEES_FAILED,

  HTTP_ATTACHMENTS_FETCHING,
  HTTP_ATTACHMENTS_SUCCESS,
  HTTP_ATTACHMENTS_FAILED,    

  HTTP_TEMPLATES_FETCHING,
  HTTP_TEMPLATES_SUCCESS,
  HTTP_TEMPLATES_FAILED,
  
  HTTP_REPORT_RESPONSE_FETCHING,
  HTTP_REPORT_RESPONSE_SUCCESS,
  HTTP_REPORT_RESPONSE_FAILED    
  
} from "../constants/meeting";

const initialState = {
  meetings: null,
  total: 0,
  isFetching: false,
  isError: false,
  event: null,
  retult: null,
  isEventFetching: false,
  isEventError: null,
  documents: null,
  isDocumentsFetching: false,
  isDocumentsError: null,
  attachments: null,
  isAttachmentsFetching: false,
  isAttachmentsError: null,
  templates: [],
  isTemplatesFetching: false,
  isTemplatesError: null,
  attendees: [],
  isAttendeesFetching: false,
  isAttendeesError: null,
  reportResponses: [],
  isreportResponsesFetching: false,
  isreportResponsesError: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HTTP_MEETINGS_SUCCESS:
      return {
        ...state,
        meetings: payload.meetings,
        isFetching: false,
        isError: false,
        total: payload.total,
      };
    case HTTP_MEETINGS_FAILED:
      return { ...state, meetings: [], isFetching: false, isError: true };
    case HTTP_MEETINGS_FETCHING:
      return { ...state, meetings: [], isFetching: true, isError: false };

    case HTTP_MEETING_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    case HTTP_MEETING_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case HTTP_MEETING_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };

    case HTTP_EVENT_SUCCESS: 
      return { ...state, event: payload, isEventFetching: false, isEventError: false };
    case HTTP_EVENT_FAILED:
      return { ...state, event: null, isEventFetching: false, isEventError: true };
    case HTTP_EVENT_FETCHING:
      return { ...state, event: null, isEventFetching: true, isEventError: false };

    case HTTP_DOCUMENTS_SUCCESS: 
      return { ...state, documents: payload, isDocumentsFetching: false, isDocumentsError: false };
    case HTTP_DOCUMENTS_FAILED:
      return { ...state, documents: null, isDocumentsFetching: false, isDocumentsError: true };
    case HTTP_DOCUMENTS_FETCHING:
      return { ...state, documents: null, isDocumentsFetching: true, isDocumentsError: false };

    case HTTP_ATTACHMENTS_SUCCESS: 
      return { ...state, attachments: payload, isAttachmentsFetching: false, isAttachmentsError: false };
    case HTTP_ATTACHMENTS_FAILED:
      return { ...state, attachments: null, isAttachmentsFetching: false, isAttachmentsError: true };
    case HTTP_ATTACHMENTS_FETCHING:
      return { ...state, attachments: null, isAttachmentsFetching: true, isAttachmentsError: false };

    case HTTP_TEMPLATES_SUCCESS: 
      return { ...state, templates: payload, isTemplatesFetching: false, isTemplatesError: false };
    case HTTP_TEMPLATES_FAILED:
      return { ...state, templates: null, isTemplatesFetching: false, isTemplatesError: true };
    case HTTP_TEMPLATES_FETCHING:
      return { ...state, templates: null, isTemplatesFetching: true, isTemplatesError: false };

    case HTTP_ATTENDEES_SUCCESS: 
      return { ...state, attendees: payload, isAttendeesFetching: false, isAttendeesError: false };
    case HTTP_ATTENDEES_FAILED:
      return { ...state, attendees: null, isAttendeesFetching: false, isAttendeesError: true };
    case HTTP_ATTENDEES_FETCHING:
      return { ...state, attendees: null, isAttendeesFetching: true, isAttendeesError: false };

    case HTTP_REPORT_RESPONSE_SUCCESS: 
      return { ...state, reportResponses: payload, isreportResponsesFetching: false, isreportResponsesError: false };
    case HTTP_REPORT_RESPONSE_FAILED:
      return { ...state, reportResponses: null, isreportResponsesFetching: false, isreportResponsesError: true };
    case HTTP_REPORT_RESPONSE_FETCHING:
      return { ...state, reportResponses: null, isreportResponsesFetching: true, isreportResponsesError: false };

    default:
      return state;
  }
};
